import { useState, useContext } from "react";
import { MdDelete, MdModeEdit } from "react-icons/md";
import { IconButton, Stack, Box, Tooltip } from "@mui/material";
//Import from project
import "../../Style/actionstyle.scss";
import { AuthContext } from "../../Context/AuthContext";
import PerformanceTypeForm from "./PerformanceTypeForm";
import DeletePerformanceType from "./DeletePerformanceType";

export default function PerformanceTypeAction({ editData, setRefetch }) {
  // Change Language
  const { t } = useContext(AuthContext);

  //Modal update
  const [openEdit, setOpenEdit] = useState(false);
  const handleOpenEdit = () => setOpenEdit(true);
  const handleCloseEdit = () => setOpenEdit(false);

  //Modal delete
  const [openDel, setOpenDel] = useState(false);
  const handleOpenDel = () => setOpenDel(true);
  const handleCloseDel = () => setOpenDel(false);

  return (
    <div>
      <Stack direction="row" justifyContent="right">
        <Tooltip title={t("update")} placement="top">
          <IconButton onClick={handleOpenEdit}>
            <Box className="update-container">
              <MdModeEdit className="update-icon" />
            </Box>
          </IconButton>
        </Tooltip>

        <Tooltip title={t("delete")} placement="top">
          <IconButton onClick={handleOpenDel}>
            <Box className="delete-container">
              <MdDelete className="delete-icon" />
            </Box>
          </IconButton>
        </Tooltip>
      </Stack>

      {openEdit && (
        <PerformanceTypeForm
          open={openEdit}
          dialogTitle={"Update"}
          editData={editData}
          setRefetch={setRefetch}
          handleClose={handleCloseEdit}
        />
      )}

      <DeletePerformanceType
        open={openDel}
        editData={editData}
        setRefetch={setRefetch}
        handleClose={handleCloseDel}
      />
    </div>
  );
}
